export const externalRedirect = (path) => {
  const config = {
    serverUrl: process.env.REACT_APP_DASHBOARD_URL,
  };
  window.location.href = config.serverUrl + path;
};
